import React from 'react';
import { useTranslation } from 'react-i18next';
import {useDispatch} from 'react-redux';
import '../../../assets/stylesheets/Shop/PurchaseItem.scss';
import {openDialog} from "../../../store/actionCreators/dialog";

const PurchaseItem = ({expiration, amount, price, label, tab, card}) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const openPurchaseDialog = () => {
      dispatch(openDialog('purchase', {title: tab, type: tab, amount, price}));
    };

    return(
        <div className={`purchaseItem ${card}`} onClick={openPurchaseDialog}>
            { expiration && <span className={`expiration`}>{expiration}</span> }
            { amount && <p className={`amount`}>{t(`shop.${tab}.${amount}`) ? t(`shop.${tab}.${amount}`) : amount}</p> }
            { label &&
                <p className={label}><span>{t(`shop.${label}`)}</span></p>
            }
            <div className={`imgContainer ${card ? 'cardContiner' : ''}`}>
                <p className={`${tab} purchaseIcon  _${amount} ${amount} ${card}`}></p>
            </div>
            { card && <p className={`cardType`}>{t(`shop.${tab}.${card}`)}</p> }
            <div className={`price`}>
                <span className={`sapphireIcon`}></span>
                <span>{price}</span>
            </div>
        </div>
    )
}
export default PurchaseItem;
